import React from 'react';
import PublicLayout from './layouts/PublicLayout.tsx';
import PublicReservationManage from './pages/public/PublicReservationManage.tsx';

const PublicReservaManageWrapper: React.FC = () => (
  <PublicLayout title="Minha reserva">
    <PublicReservationManage />
  </PublicLayout>
);

export default PublicReservaManageWrapper;
